import { computed } from '@ember/object';
import getWithZeroDefault from '@intercom/pulse/lib/get-with-zero-default';

export default function subtractProperties(dependentKey, deltaKey) {
  return computed(dependentKey, deltaKey, function () {
    return getWithZeroDefault(this, dependentKey) - getWithZeroDefault(this, deltaKey);
  });
}
